export enum PaymentMerchants {
  MONDIDO = 'mondido',
  SWISH = 'swish'
}
export const DEPRECATED_PAYMENT_GATEWAYS: PaymentMerchants[] = [PaymentMerchants.MONDIDO];

export const ALLOWED_PAYMENT_MERCHANTS = ['SWISH'] as const;

export interface IUnsavedMondidoMerchant {
  merchant_id?: string;
  secret: string;
  password: string;
  payment_gateway: PaymentMerchants.MONDIDO;
}

export interface IMondidoMerchant {
  id: number;
  merchantId: string;
}

export interface IMondidoMerchant {
  id: number;
  merchantId: string;
}

export interface IUnsavedSwishMerchant {
  payee_alias: string;
  key_password: string;
  payment_gateway: PaymentMerchants.SWISH;
}

export interface ISwishMerchant {
  id: number;
  payee_alias: string;
  merchant_cert_uploaded: boolean;
  server_tls_cert_uploaded: boolean;
  merchant_cert_key_uploaded: boolean;
}

export interface IMerchantsInfo {
  mondido?: IMondidoMerchant;
  swish?: ISwishMerchant;
}

export interface IAvailableGateway {
  id: PaymentMerchants;
  description: string;
  payment_gateway: PaymentMerchants;
}
